import { BidsHeader } from '../models/bids-header';

export const myBidsHeaders: BidsHeader[] = [
  { title: 'Bid Date', SearchItem: 'BidDateTime', IsReversed: true, IsDefault: true, Size: 2 },
  { title: 'Id', SearchItem: 'InternalId', IsReversed: false, IsDefault: false, Size: 3 },
  { title: 'Name', SearchItem: 'ProjectTitle', IsReversed: false, IsDefault: false, Size: 7 }
];
